/** Zustand persist key — must match ui.store and index.html FOUC script. */
export const UI_STORE_KEY = 'ui-store';

export type ThemeMode = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export function getSystemTheme(): ResolvedTheme {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function resolveTheme(mode: ThemeMode): ResolvedTheme {
  if (mode === 'system') return getSystemTheme();
  return mode;
}

/** Read persisted preference before React mounts (FOUC prevention). */
export function readStoredThemeMode(): ThemeMode {
  if (typeof window === 'undefined') return 'system';

  try {
    const raw = localStorage.getItem(UI_STORE_KEY);
    if (!raw) return 'system';

    const parsed = JSON.parse(raw) as { state?: { theme?: ThemeMode } };
    const theme = parsed?.state?.theme;
    if (theme === 'light' || theme === 'dark' || theme === 'system') return theme;
  } catch {
    /* ignore malformed storage */
  }

  return 'system';
}

/** Apply resolved theme to the document root. */
export function applyResolvedTheme(resolved: ResolvedTheme): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  if (resolved === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  root.style.colorScheme = resolved;
}

export function applyTheme(mode: ThemeMode): void {
  applyResolvedTheme(resolveTheme(mode));
}

/** Inline bootstrap — keep in sync with this module (used in index.html). */
export function bootstrapThemeFromStorage(): void {
  applyTheme(readStoredThemeMode());
}
